/**
 * Trạng thái kết nối tài khoản kênh — realtime TOÀN ỨNG DỤNG.
 *
 * Trước đây chỉ màn Hội thoại nghe `zalo:account-status`, nên ở trang Kết nối
 * (Tích hợp) một tài khoản Zalo rớt vẫn hiện "Đã kết nối" tới khi tải lại trang.
 * Hook này gắn một lần ở AppLayout: mọi màn dùng useZaloAccounts (trang Kết nối,
 * bộ chọn tài khoản, dải cảnh báo trên ô soạn tin) đều cập nhật ngay.
 */
import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { getSocket } from '@/lib/socket'

/** Sự kiện socket làm danh sách tài khoản kênh cần tải lại. */
export const ACCOUNT_STATUS_EVENTS = ['zalo:account-status', 'zalo:connected', 'connect'] as const

export function useAccountStatusRealtime() {
  const qc = useQueryClient()

  useEffect(() => {
    const socket = getSocket()
    // 'connect' = socket vừa (kết nối) lại → có thể đã lỡ sự kiện, tải lại cho chắc.
    const invalidate = () => {
      qc.invalidateQueries({ queryKey: ['integrations', 'zalo-accounts'] })
    }
    for (const ev of ACCOUNT_STATUS_EVENTS) socket.on(ev, invalidate)
    return () => {
      for (const ev of ACCOUNT_STATUS_EVENTS) socket.off(ev, invalidate)
    }
  }, [qc])
}
